<script>
  import { Router, Route } from 'svelte-routing';
  import Dashboard from '../../components/App/Dashboard/index.svelte';
  import BatchFullData from '../../pages/batch/index.svelte';
  import UpdateBatch from '../../components/App/Batch/UpdateBatch/index.svelte';


  export let url = '';
</script>

<Router {url}>
    <Route path="/"><Dashboard/></Route>
    <Route path="batch/:id" let:params>
      <BatchFullData id="{params.id}"/>
    </Route>

    <Route path="edit/:id" let:params>
      <UpdateBatch id="{params.id}"/>
    </Route>

</Router>


<style >
  

</style>